import { render, staticRenderFns } from "./preservationList.vue?vue&type=template&id=554cf995&scoped=true"
import script from "./preservationList.vue?vue&type=script&lang=js"
export * from "./preservationList.vue?vue&type=script&lang=js"
import style0 from "./preservationList.vue?vue&type=style&index=0&id=554cf995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554cf995",
  null
  
)

export default component.exports